import { createAction, Dispatch } from '@reduxjs/toolkit';
import { AppError } from '../../types/appError';
import { SmppboxModel } from '../../models/smppboxModel';
import { AppDispatch, RootState } from '../store';
import SmppboxApi from '../../api/smppboxApi';
import { addMinutes, isExpired } from '../../utils/datetimeUtils';
import { selectSmppboxByServerId } from './smppboxSelector';

const DEFAULT_SMPPBOX_STATUS_EXP_PERIOD_IN_MINUTES = 5;

const getSmppboxStatusExpirationPeriodInMinutesOrDefault = (): number => (
  process.env.REACT_APP_SMPPBOX_STATUS_EXP_PERIOD_IN_MINUTES
    ? parseInt(process.env.REACT_APP_SMPPBOX_STATUS_EXP_PERIOD_IN_MINUTES, 10)
    : DEFAULT_SMPPBOX_STATUS_EXP_PERIOD_IN_MINUTES
);

const isOutdatedSmppboxStatus = (smppbox: SmppboxModel): boolean => {
  const expirationPeriodInMinutes = getSmppboxStatusExpirationPeriodInMinutesOrDefault();
  const outdatedTime = addMinutes(smppbox.fetchedAt, expirationPeriodInMinutes);

  return isExpired(outdatedTime);
};

export const smppboxFetchRequestAction = createAction<{ serverId: string }>('smppbox/fetchRequest');
export const smppboxFetchSuccessAction = createAction<SmppboxModel>('smppbox/fetchSuccess');
export const smppboxFetchFailureAction = createAction<{ serverId: string, error: AppError }>('smppbox/fetchFailure');

export const fetchSmppboxIfOutdated = (serverId: string) => (
  async (dispatch: AppDispatch, getState: () => RootState) => {
    const smppbox = selectSmppboxByServerId(getState(), serverId);

    if (!smppbox || isOutdatedSmppboxStatus(smppbox)) {
      dispatch(fetchSmppboxByServerId(serverId));
    }
  }
);

export const fetchSmppboxByServerId = (serverId: string) => async (dispatch: Dispatch) => {
  dispatch(smppboxFetchRequestAction({ serverId }));
  try {
    const smppboxModel = await SmppboxApi.fetchSmppbox(serverId);
    dispatch(smppboxFetchSuccessAction(smppboxModel));
  } catch (error) {
    dispatch(smppboxFetchFailureAction({ serverId, error: error as AppError }));
  }
};
